import { Menu, Bell, Search, LogOut } from 'lucide-react';
import ClockInWidget from './ClockInWidget';
import EnableNotificationsButton from './EnableNotificationsButton';

interface TopBarProps {
  onMenuClick: () => void;
  onLogout: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ onMenuClick, onLogout }) => {
  return (
    <header className="bg-white border-b border-gray-200 shadow-sm">
      <div className="flex h-16 items-center justify-between px-6">
        <button 
          onClick={onMenuClick}
          className="inline-flex h-10 w-10 items-center justify-center rounded-md text-gray-500 hover:text-gray-900 lg:hidden"
        >
          <Menu className="h-6 w-6" />
        </button>
        
        <div className="flex flex-1 items-center justify-between">
          <div className="relative w-full max-w-md">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              placeholder="Buscar usuários, mensagens..."
              className="block w-full rounded-md border border-gray-300 bg-white py-2 pl-10 pr-3 text-sm placeholder-gray-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>
          
          <div className="flex items-center space-x-4">
            <EnableNotificationsButton />
            <ClockInWidget />
            <button className="relative p-2 text-gray-500 hover:text-gray-900">
              <Bell className="h-6 w-6" />
              <span className="absolute top-0 right-0 h-2 w-2 bg-red-500 rounded-full"></span>
            </button>
            <button 
              onClick={onLogout}
              className="flex items-center space-x-1 text-gray-700 hover:text-red-600"
            >
              <LogOut className="h-5 w-5" />
              <span className="text-sm font-medium">Sair</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopBar;